import React from "react";
import { Route } from "react-router-dom";

const protectedRouteConfig = {
    routes: [
    ]
};

export default protectedRouteConfig;